import React from "react";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

function CustomizeSummaryCardsButton(props) {
  return (
    <MenuItem
      onClick={() => {
        props.openCustomizeSummaryCards();
        props.onMenuItemClick?.();
      }}
      sx={{ py: 1.25 }}
    >
      <ListItemIcon>
        <DashboardCustomizeOutlinedIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText
        primaryTypographyProps={{ fontSize: 14 }}
      >
        Customize summary cards
      </ListItemText>
    </MenuItem>
  );
}

export default CustomizeSummaryCardsButton;
